import React from 'react';
import * as S from './BackTop.styled';

function BackTopPage({ icon, backgroundColor, color }) {
  return (
    <aside aria-label="Voltar ao topo da página">
      <S.BackTop aria-label="Voltar ao topo">
        <S.BackTopStyle backgroundColor={backgroundColor} color={color}>
          {icon}
        </S.BackTopStyle>
      </S.BackTop>
    </aside>
  );
}

export default BackTopPage;

BackTopPage.defaultProps = {
  icon: 'UP',
  backgroundColor: '#009688',
  color: '#fff',
};
